import { Box, Stack, Typography } from "@mui/material";
import { formatCurrency } from "../../../utils/formatters";
import { useData } from "../../../utils/useData";
import { ModuleFeeTooltip } from "../Standard/Tooltips/ModuleFeeTooltip";

export const PublicTransportCheckoutProductDetails = ({ monthlyUserFee }: { monthlyUserFee: number }) => {

  return (
    <Box>
      <Typography variant="h6" paddingBottom={2}>
        Module Information
      </Typography>
      <Typography textAlign={"justify"}>
        Give your team the option to pay for public transport with pre-tax
        income. Employees save up to $768/year on a $70K salary. Simple to
        implement, fully compliant, with real-time tracking. Boost employee
        satisfaction, office attendance, and sustainability. No FBT, no hassle.
      </Typography>

      <Stack
        direction={"row"}
        sx={{ marginTop: 8, marginBottom: 1 }}
        alignItems={"center"}
        alignContent={"center"}
      >
        <Typography variant="h6" textAlign={"justify"}>
          Module Fee
        </Typography>
        <ModuleFeeTooltip />
      </Stack>
      <Typography textAlign={"justify"}>
        {formatCurrency(monthlyUserFee)}/month per user
      </Typography>
    </Box>
  );
};
